// document.addEventListener('DOMContentLoaded', function() {
//     var productGrids = document.querySelectorAll('.grid.product-grid');
//     var viewState = 'One'; // Default to "One"

//     // Toggle buttons for switching views
//     var viewByOneButton = document.getElementById("global-view-one");
//     var viewByTwoButton = document.getElementById("global-view-two");

//     if (viewByOneButton && viewByTwoButton) {
//         viewByOneButton.addEventListener("click", function () {
//             viewState = 'One';
//             viewByOneButton.classList.add("active");
//             viewByTwoButton.classList.remove("active");
//             toggleImages('one');
//         });

//         viewByTwoButton.addEventListener("click", function () {
//             viewState = 'Two';
//             viewByTwoButton.classList.add("active");
//             viewByOneButton.classList.remove("active");
//             toggleImages('two');
//         });
//     }

//     // Function to toggle images based on view state
//  //   function toggleImages(view) {
//   //      document.querySelectorAll('.view-image-one').forEach(img => img.style.display = view === 'one' ? 'block' : 'none');
//  //       document.querySelectorAll('.view-image-two').forEach(img => img.style.display = view === 'two' ? 'block' : 'none');
// //    }

//     // Function to set the image based on variant data and view state
//     function setImageForView(card, variantData, viewClass) {
//         var productImageElement = card.querySelector(`.card__media .${viewClass}`);
//         if (productImageElement) {
//             var lazyLoadAllVariants = card.getAttribute('data-lazy-load-all-variants') === 'true';
//             if (lazyLoadAllVariants) {
//                 var preloadedImage = card.querySelector(`img[data-variant-id="${variantData.variantId}"]`);
//                 if (preloadedImage) {
//                     productImageElement.src = preloadedImage.src;
//                     productImageElement.srcset = preloadedImage.srcset;
//                 } else {
//                     console.log('Matching preloaded image not found for variant:', variantData.variantId);
//                 }
//             } else {
//                 // Update src and srcset for responsive images
//                 var dynamicSrcset = [
//                     variantData.imageUrl + '?width=165 165w',
//                     variantData.imageUrl + '?width=360 360w',
//                     variantData.imageUrl + '?width=533 533w',
//                     variantData.imageUrl + '?width=720 720w',
//                     variantData.imageUrl + '?width=940 940w',
//                     variantData.imageUrl + '?width=1066 1066w'
//                 ].join(', ');
//                 productImageElement.src = variantData.imageUrl;
//                 productImageElement.srcset = dynamicSrcset;
//             }
//             productImageElement.style.display = 'block';
//         } else {
//             console.log(`No product image element found for view: ${viewClass}`);
//         }
//     }

//     productGrids.forEach(function(productGrid) {
//         var sectionId = productGrid.getAttribute('data-section-id');
//         var variantDataMap = window['variantDataMap' + sectionId.replace(/-/g, '_')];
        
//         productGrid.addEventListener('change', function(e) {
//             if (e.target.matches('input[type="radio"][data-section-id="' + sectionId + '"]')) {
//                 var card = e.target.closest(`.card-product-custom-div[data-section-id="${sectionId}"]`);
//                 var variantId = e.target.getAttribute('data-variant-id');
//                 var variantData = variantDataMap[variantId];
                
//                 if (!variantData) {
//                     console.log('No data found for variant:', variantId);
//                     return;
//                 }

//                 // Update image based on current view state
//                 if (viewState === 'One') {
//                     setImageForView(card, variantData, 'view-image-one');
//                 } else {
//                     setImageForView(card, variantData, 'view-image-two');
//                 }

//                 // Update the product URL
//                 var productLinks = card.querySelectorAll('a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"]');
//                 productLinks.forEach(function(link) {
//                     link.href = variantData.productUrl;
//                 });
//             } else {
//                 console.log('Change detected, but not on a swatch input.');
//             }
//         });
//     });
// });


// OLD CODE 

// (function () {
//   'use strict';

//   const GRID_SELECTOR = '.grid.product-grid';
//   const fetchedProductCache = {};
//   const fuzzyMapCache = {};
//   const MAX_POLL_TIME = 8000;
//   const POLL_INTERVAL = 200;

//   function findCandidateGrids(root = document) {
//     return Array.from(root.querySelectorAll(GRID_SELECTOR));
//   }

//   function inferSectionId(el) {
//     while (el && el !== document.documentElement) {
//       if (el.getAttribute && el.getAttribute('data-section-id')) return el.getAttribute('data-section-id');
//       el = el.parentNode;
//     }
//     return null;
//   }

//   function normalizeSectionKey(sectionId) {
//     return sectionId ? sectionId.replace(/[-]/g, '_').replace(/__+/g, '_') : null;
//   }

//   function getVariantFromWindowMaps(sectionId, variantId) {
//     if (!variantId) return null;
//     const normalized = normalizeSectionKey(sectionId);

//     if (normalized) {
//       const exactKey = 'variantDataMap' + normalized;
//       const exactMap = window[exactKey];
//       if (exactMap && exactMap[variantId]) return exactMap[variantId];
//     }

//     if (fuzzyMapCache[sectionId]) {
//       const map = fuzzyMapCache[sectionId];
//       if (map[variantId]) return map[variantId];
//     }

//     for (const key in window) {
//       if (key.startsWith('variantDataMap')) {
//         const map = window[key];
//         if (map && typeof map === 'object' && map[variantId]) {
//           fuzzyMapCache[sectionId] = map;
//           return map[variantId];
//         }
//       }
//     }
//     return null;
//   }

//   function getVariantFromDOM(eTarget, card, variantId) {
//     if (eTarget && eTarget.dataset) {
//       const t = eTarget.dataset;
//       if (t.imageUrl || t.image || t.imageUrlSrc || t.src || t.productUrl || t.href) {
//         return { variantId, imageUrl: t.imageUrl || t.image || t.imageUrlSrc || t.src, productUrl: t.productUrl || t.href };
//       }
//     }
//     if (card && card.dataset) {
//       const d = card.dataset;
//       if (d.variantImage || d.imageUrl || d.productImage || d.productHandle || d.handle || d.productUrl) {
//         return {
//           variantId,
//           imageUrl: d.variantImage || d.imageUrl || d.productImage,
//           productUrl: d.productUrl,
//           productHandle: d.productHandle || d.handle
//         };
//       }
//     }
//     return null;
//   }

//   async function fetchVariantFromProductHandle(handle, variantId) {
//     if (!handle) return null;
//     if (fetchedProductCache[handle]) {
//       const prod = fetchedProductCache[handle];
//       const found = prod.variants && prod.variants.find(v => String(v.id) === String(variantId));
//       return found ? buildVariantDataFromProductVariant(found, prod) : null;
//     }

//     const res = await fetch(`/products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin' });
//     if (!res.ok) return null;
//     const productJson = await res.json();
//     fetchedProductCache[handle] = productJson;
//     const variant = productJson.variants.find(v => String(v.id) === String(variantId));
//     return variant ? buildVariantDataFromProductVariant(variant, productJson) : null;
//   }

//   function buildVariantDataFromProductVariant(variant, productJson) {
//     const img = variant?.featured_image?.src || variant?.featured_image || productJson.images?.[0] || null;
//     return {
//       variantId: String(variant.id),
//       imageUrl: img,
//       productUrl: productJson.handle ? `/products/${productJson.handle}` : productJson.url || null
//     };
//   }

//   function extractHandleFromHref(href) {
//     if (!href) return null;
//     const m = href.split('?')[0].match(/\/products\/([^\/]+)/);
//     return m ? decodeURIComponent(m[1]) : null;
//   }

//   function setImageForView(card, variantData, viewClass) {
//     if (!card || !variantData) return;
//     const el = card.querySelector(`.card__media .${viewClass}`);
//     if (!el) return;

//     if (variantData.imageUrl) {
//       const srcset = [
//         `${variantData.imageUrl}?width=165 165w`,
//         `${variantData.imageUrl}?width=360 360w`,
//         `${variantData.imageUrl}?width=533 533w`,
//         `${variantData.imageUrl}?width=720 720w`,
//         `${variantData.imageUrl}?width=940 940w`,
//         `${variantData.imageUrl}?width=1066 1066w`
//       ].join(', ');
//       el.src = variantData.imageUrl;
//       el.srcset = srcset;
//     }

//     if (variantData.productUrl) {
//       card.querySelectorAll('a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"], a[href*="/products/"]').forEach(a => {
//         a.href = variantData.productUrl;
//       });
//     }
//   }

//   function initializeGrid(gridEl) {
//     if (!gridEl || gridEl.dataset.gridInitialized === 'true') return;
//     gridEl.dataset.gridInitialized = 'true';

//     const sectionId = gridEl.getAttribute('data-section-id') || inferSectionId(gridEl);

//     gridEl.addEventListener('change', async e => {
//       if (!e.target.matches('input[type="radio"][data-variant-id], input[type="checkbox"][data-variant-id]')) return;
//       const variantId = e.target.getAttribute('data-variant-id');
//       const card = e.target.closest(`.card-product-custom-div[data-section-id="${sectionId}"]`)
//         || e.target.closest('.card-product-custom-div')
//         || e.target.closest('li, .card, .product-card');

//       let variantData = getVariantFromWindowMaps(sectionId, variantId)
//         || getVariantFromDOM(e.target, card, variantId);

//       if (variantData) {
//         setImageForView(card, variantData, window.__globalViewState === 'Two' ? 'view-image-two' : 'view-image-one');
//         return;
//       }

//       let handle = card?.dataset?.productHandle || card?.dataset?.handle;
//       if (!handle && card) {
//         const link = card.querySelector('a[href*="/products/"]');
//         if (link) handle = extractHandleFromHref(link.href);
//       }
//       if (!handle && e.target.dataset) handle = e.target.dataset.productHandle || e.target.dataset.handle;

//       if (handle) {
//         const fetched = await fetchVariantFromProductHandle(handle, variantId);
//         if (fetched) {
//           setImageForView(card, fetched, window.__globalViewState === 'Two' ? 'view-image-two' : 'view-image-one');
//           return;
//         }
//       }

//       for (const key in window) {
//         if (key.startsWith('variantDataMap')) {
//           const map = window[key];
//           if (map && typeof map === 'object' && map[variantId]) {
//             fuzzyMapCache[sectionId] = map;
//             setImageForView(card, map[variantId], window.__globalViewState === 'Two' ? 'view-image-two' : 'view-image-one');
//             return;
//           }
//         }
//       }
//     }, { passive: true });
//   }

//   function initFoundGrids(root = document) {
//     const grids = findCandidateGrids(root);
//     for (let i = 0; i < grids.length; i++) initializeGrid(grids[i]);
//     return grids.length;
//   }

//   function pollForGrids(maxTime = MAX_POLL_TIME, interval = POLL_INTERVAL) {
//     return new Promise(resolve => {
//       let elapsed = 0;
//       const id = setInterval(() => {
//         const c = initFoundGrids();
//         if (c > 0 || (elapsed += interval) >= maxTime) {
//           clearInterval(id);
//           resolve();
//         }
//       }, interval);
//     });
//   }

//   function attachObserver() {
//     if (window.__productGridObserverAttached) return;
//     window.__productGridObserverAttached = true;

//     const observer = new MutationObserver(muts => {
//       const set = new Set();
//       muts.forEach(m => {
//         m.addedNodes.forEach(node => {
//           if (node instanceof HTMLElement) {
//             if (node.matches?.(GRID_SELECTOR)) set.add(node);
//             node.querySelectorAll?.(GRID_SELECTOR).forEach(el => set.add(el));
//           }
//         });
//       });
//       if (set.size) requestAnimationFrame(() => set.forEach(g => initializeGrid(g)));
//     });

//     observer.observe(document.body, { childList: true, subtree: true });
//   }

//   function bootstrap() {
//     const immediate = initFoundGrids();
//     if (immediate === 0) {
//       attachObserver();
//       pollForGrids();
//     }

//     if (typeof jQuery !== 'undefined' && jQuery.fn?.slick) {
//       jQuery(document).on('init reInit setPosition', '.slick-slider', (e, slick) => {
//         initFoundGrids(slick?.$slider?.[0] || document);
//       });
//     }
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', bootstrap);
//   } else {
//     bootstrap();
//   }

//   document.addEventListener('shopify:section:load', e => initFoundGrids(e.target || document));
//   document.addEventListener('shopify:section:reorder', () => initFoundGrids());

//   window.__initProductVariantGridLogic = () => initFoundGrids();

//   /* ------------------------------------------------------------------ *
//    * Auto-select colors on collection pages
//    * ------------------------------------------------------------------ */

//   // Default color applied to EVERY product on the matching collection page.
//   const COLLECTION_COLOR_MAP = {
//     'light-pink-ss26': 'Light Pink,Nude',
//     'high-summer-diva': 'Diva',
//     'high-summer-the-red-thread': 'Red Thread',
//   };

//   // Per-product overrides: collection slug -> { 'product-handle': 'Color' }.
//   // Any product NOT listed here falls back to COLLECTION_COLOR_MAP above.
//   // The product handle is the last part of its URL: /products/THIS-PART
//   const COLLECTION_PRODUCT_COLOR_OVERRIDES = {
//     'high-summer-diva': {
//       'olivia-poplin-bolero':  'Black',
//       'celia-poplin-shorts': 'Black',
//     },
//   };

//   function getCurrentCollectionSlug() {
//     return Object.keys(COLLECTION_COLOR_MAP).find(slug =>
//       window.location.pathname.includes(slug)
//     ) || null;
//   }

//   function getColorForCurrentPage() {
//     const slug = getCurrentCollectionSlug();
//     return slug ? COLLECTION_COLOR_MAP[slug] : null;
//   }

//   function getCardHandle(card) {
//     let handle = card?.dataset?.productHandle || card?.dataset?.handle;
//     if (!handle) {
//       const link = card?.querySelector('a[href*="/products/"]');
//       if (link) handle = extractHandleFromHref(link.href);
//     }
//     return handle || null;
//   }

//   function getColorForCard(card, slug) {
//     const overrides = COLLECTION_PRODUCT_COLOR_OVERRIDES[slug];
//     const handle = getCardHandle(card);
//     if (overrides && handle && overrides[handle]) return overrides[handle];
//     return COLLECTION_COLOR_MAP[slug];
//   }

//   function selectColorOnCard(card, slug) {
//     const color = getColorForCard(card, slug);
//     if (!color) return;
//     const input = card.querySelector(`input[type="radio"][value="${color}"]`);
//     if (input && !input.checked) {
//       input.checked = true;
//       input.dispatchEvent(new Event('change', { bubbles: true }));
//     }
//   }

//   function autoSelectColor(scope = document) {
//     const slug = getCurrentCollectionSlug();
//     if (!slug) return;

//     const cards = [];
//     if (scope.matches?.('.card-product-custom-div')) cards.push(scope);
//     scope.querySelectorAll?.('.card-product-custom-div').forEach(c => cards.push(c));

//     cards.forEach(card => selectColorOnCard(card, slug));
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', () => autoSelectColor());
//   } else {
//     autoSelectColor();
//   }

//   document.addEventListener('products:loaded', (e) => {
//     if (!getCurrentCollectionSlug()) return;
//     (e.detail?.items || []).forEach(item => autoSelectColor(item));
//   });
//   // Auto-select colors on collection pages end

//   /* ------------------------------------------------------------------ *
//    * Auto-select first variant on page load
//    * (skipped on pages handled by the color logic above)
//    * ------------------------------------------------------------------ */
//   function autoSelectFirstVariant(scope = document) {
//     if (getColorForCurrentPage()) return;

//     scope.querySelectorAll('.card-product-custom-div').forEach(card => {
//       const firstInput = card.querySelector('input[type="radio"][data-variant-id]');
//       if (!firstInput) return;
//       firstInput.checked = true;
//       firstInput.dispatchEvent(new Event('change', { bubbles: true }));
//     });
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', () => autoSelectFirstVariant());
//   } else {
//     autoSelectFirstVariant();
//   }

//   // For infinite scroll / lazy loaded products
//   document.addEventListener('products:loaded', (e) => {
//     if (getColorForCurrentPage()) return;
//     const newItems = e.detail?.items;
//     if (!newItems) return;
//     newItems.forEach(item => autoSelectFirstVariant(item));
//   });
// })();


//NEW CODE
(function () {
  'use strict';

  const GRID_SELECTOR = '.grid.product-grid';
  const fetchedProductCache = {};
  const fuzzyMapCache = {};
  const MAX_POLL_TIME = 8000;
  const POLL_INTERVAL = 200;

  function findCandidateGrids(root = document) {
    return Array.from(root.querySelectorAll(GRID_SELECTOR));
  }

  function inferSectionId(el) {
    while (el && el !== document.documentElement) {
      if (el.getAttribute && el.getAttribute('data-section-id')) return el.getAttribute('data-section-id');
      el = el.parentNode;
    }
    return null;
  }

  function normalizeSectionKey(sectionId) {
    return sectionId ? sectionId.replace(/[-]/g, '_').replace(/__+/g, '_') : null;
  }

  function getVariantFromWindowMaps(sectionId, variantId) {
    if (!variantId) return null;
    const normalized = normalizeSectionKey(sectionId);

    if (normalized) {
      const exactKey = 'variantDataMap' + normalized;
      const exactMap = window[exactKey];
      if (exactMap && exactMap[variantId]) return exactMap[variantId];
    }

    if (fuzzyMapCache[sectionId]) {
      const map = fuzzyMapCache[sectionId];
      if (map[variantId]) return map[variantId];
    }

    for (const key in window) {
      if (key.startsWith('variantDataMap')) {
        const map = window[key];
        if (map && typeof map === 'object' && map[variantId]) {
          fuzzyMapCache[sectionId] = map;
          return map[variantId];
        }
      }
    }
    return null;
  }

  function getVariantFromDOM(eTarget, card, variantId) {
    if (eTarget && eTarget.dataset) {
      const t = eTarget.dataset;
      if (t.imageUrl || t.image || t.imageUrlSrc || t.src || t.productUrl || t.href) {
        return { variantId, imageUrl: t.imageUrl || t.image || t.imageUrlSrc || t.src, productUrl: t.productUrl || t.href };
      }
    }
    if (card && card.dataset) {
      const d = card.dataset;
      if (d.variantImage || d.imageUrl || d.productImage || d.productHandle || d.handle || d.productUrl) {
        return {
          variantId,
          imageUrl: d.variantImage || d.imageUrl || d.productImage,
          productUrl: d.productUrl,
          productHandle: d.productHandle || d.handle
        };
      }
    }
    return null;
  }

  async function fetchVariantFromProductHandle(handle, variantId) {
    if (!handle) return null;
    if (fetchedProductCache[handle]) {
      const prod = fetchedProductCache[handle];
      const found = prod.variants && prod.variants.find(v => String(v.id) === String(variantId));
      return found ? buildVariantDataFromProductVariant(found, prod) : null;
    }

    const res = await fetch(`/products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin' });
    if (!res.ok) return null;
    const productJson = await res.json();
    fetchedProductCache[handle] = productJson;
    const variant = productJson.variants.find(v => String(v.id) === String(variantId));
    return variant ? buildVariantDataFromProductVariant(variant, productJson) : null;
  }

  function buildVariantDataFromProductVariant(variant, productJson) {
    const img = variant?.featured_image?.src || variant?.featured_image || productJson.images?.[0] || null;
    return {
      variantId: String(variant.id),
      imageUrl: img,
      productUrl: productJson.handle ? `/products/${productJson.handle}` : productJson.url || null
    };
  }

  function extractHandleFromHref(href) {
    if (!href) return null;
    const m = href.split('?')[0].match(/\/products\/([^\/]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  // Repoints ALL of a card's product links at the given variant (adds ?variant=<id>),
  // so clicking through opens the PDP on exactly the swatch that's selected.
  function setCardLinksToVariant(card, variantId) {
    if (!card || !variantId) return;
    card.querySelectorAll('a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"], a[href*="/products/"]').forEach(a => {
      const raw = a.getAttribute('href');
      if (!raw) return;
      try {
        const u = new URL(raw, window.location.origin);
        if (!u.pathname.includes('/products/')) return;
        u.searchParams.set('variant', variantId);
        a.setAttribute('href', u.pathname + u.search + u.hash);
      } catch (_) { /* ignore malformed hrefs */ }
    });
  }

  function setImageForView(card, variantData, viewClass) {
    if (!card || !variantData) return;
    const el = card.querySelector(`.card__media .${viewClass}`);
    if (!el) return;

    if (variantData.imageUrl) {
      const srcset = [
        `${variantData.imageUrl}?width=165 165w`,
        `${variantData.imageUrl}?width=360 360w`,
        `${variantData.imageUrl}?width=533 533w`,
        `${variantData.imageUrl}?width=720 720w`,
        `${variantData.imageUrl}?width=940 940w`,
        `${variantData.imageUrl}?width=1066 1066w`
      ].join(', ');
      el.src = variantData.imageUrl;
      el.srcset = srcset;
    }
  }

  function initializeGrid(gridEl) {
    if (!gridEl || gridEl.dataset.gridInitialized === 'true') return;
    gridEl.dataset.gridInitialized = 'true';

    const sectionId = gridEl.getAttribute('data-section-id') || inferSectionId(gridEl);

    gridEl.addEventListener('change', async e => {
      if (!e.target.matches('input[type="radio"][data-variant-id], input[type="checkbox"][data-variant-id]')) return;
      const variantId = e.target.getAttribute('data-variant-id');
      const card = e.target.closest(`.card-product-custom-div[data-section-id="${sectionId}"]`)
        || e.target.closest('.card-product-custom-div')
        || e.target.closest('li, .card, .product-card');

      // Universal: whichever swatch is selected, point this card's links at that variant.
      if (card && variantId) setCardLinksToVariant(card, variantId);

      let variantData = getVariantFromWindowMaps(sectionId, variantId)
        || getVariantFromDOM(e.target, card, variantId);

      if (variantData) {
        setImageForView(card, variantData, window.__globalViewState === 'Two' ? 'view-image-two' : 'view-image-one');
        return;
      }

      let handle = card?.dataset?.productHandle || card?.dataset?.handle;
      if (!handle && card) {
        const link = card.querySelector('a[href*="/products/"]');
        if (link) handle = extractHandleFromHref(link.href);
      }
      if (!handle && e.target.dataset) handle = e.target.dataset.productHandle || e.target.dataset.handle;

      if (handle) {
        const fetched = await fetchVariantFromProductHandle(handle, variantId);
        if (fetched) {
          setImageForView(card, fetched, window.__globalViewState === 'Two' ? 'view-image-two' : 'view-image-one');
          return;
        }
      }

      for (const key in window) {
        if (key.startsWith('variantDataMap')) {
          const map = window[key];
          if (map && typeof map === 'object' && map[variantId]) {
            fuzzyMapCache[sectionId] = map;
            setImageForView(card, map[variantId], window.__globalViewState === 'Two' ? 'view-image-two' : 'view-image-one');
            return;
          }
        }
      }
    }, { passive: true });
  }

  function initFoundGrids(root = document) {
    const grids = findCandidateGrids(root);
    for (let i = 0; i < grids.length; i++) initializeGrid(grids[i]);
    return grids.length;
  }

  function pollForGrids(maxTime = MAX_POLL_TIME, interval = POLL_INTERVAL) {
    return new Promise(resolve => {
      let elapsed = 0;
      const id = setInterval(() => {
        const c = initFoundGrids();
        if (c > 0 || (elapsed += interval) >= maxTime) {
          clearInterval(id);
          resolve();
        }
      }, interval);
    });
  }

  function attachObserver() {
    if (window.__productGridObserverAttached) return;
    window.__productGridObserverAttached = true;

    const observer = new MutationObserver(muts => {
      const set = new Set();
      muts.forEach(m => {
        m.addedNodes.forEach(node => {
          if (node instanceof HTMLElement) {
            if (node.matches?.(GRID_SELECTOR)) set.add(node);
            node.querySelectorAll?.(GRID_SELECTOR).forEach(el => set.add(el));
          }
        });
      });
      if (set.size) requestAnimationFrame(() => set.forEach(g => initializeGrid(g)));
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function bootstrap() {
    const immediate = initFoundGrids();
    if (immediate === 0) {
      attachObserver();
      pollForGrids();
    }

    if (typeof jQuery !== 'undefined' && jQuery.fn?.slick) {
      jQuery(document).on('init reInit setPosition', '.slick-slider', (e, slick) => {
        initFoundGrids(slick?.$slider?.[0] || document);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  document.addEventListener('shopify:section:load', e => initFoundGrids(e.target || document));
  document.addEventListener('shopify:section:reorder', () => initFoundGrids());

  window.__initProductVariantGridLogic = () => initFoundGrids();

  /* ------------------------------------------------------------------ *
   * Auto-select colors on collection pages
   * ------------------------------------------------------------------ */

  // Default color(s) applied to EVERY product on the matching collection page.
  // Value can be a single color string, OR an array of colors tried in order
  // (first one that exists on the product wins).
  //
  // NOTE: snippets/variant-swatch-collection.liquid carries the same map so the
  // target color is rendered FIRST (only 3 swatches render per card, so a color
  // sitting 4th+ in the option list would otherwise never exist in the DOM for
  // this script to select). Keep both lists in sync.
  const COLLECTION_COLOR_MAP = {
    'light-pink-ss26': 'Light Pink',
    'high-summer-diva': 'Diva',
    'high-summer-the-red-thread': 'Red Thread',
    'the-silver-lining': ['Light Grey', 'Dusty Grey'],
    'mary-danya': ['White', 'Off White'],
    'shades-of-green': ['Olive', 'Warm Khaki'],
    'protected': 'Red Thread',
    'shades-of-blue': ['Navy', 'Blue', 'Deep Blue']
  };

  // Per-product overrides: collection slug -> { 'product-handle': 'Color' }.
  // Any product NOT listed here falls back to COLLECTION_COLOR_MAP above.
  // The product handle is the last part of its URL: /products/THIS-PART
  const COLLECTION_PRODUCT_COLOR_OVERRIDES = {
    'high-summer-diva': {
      'olivia-poplin-bolero':  'Black',
      'celia-poplin-shorts': 'Black',
    },
  };

  function getCurrentCollectionSlug() {
    return Object.keys(COLLECTION_COLOR_MAP).find(slug =>
      window.location.pathname.includes(slug)
    ) || null;
  }

  // Customer's live filter selection wins over the collection's hardcoded default
function getFilterColorsFromURL() {
  const params = new URLSearchParams(window.location.search);
  const colors = params.getAll('filter.v.option.color').filter(Boolean);
  return colors.length ? colors : null;
}

  function getColorForCurrentPage() {
    const slug = getCurrentCollectionSlug();
    return slug ? COLLECTION_COLOR_MAP[slug] : null;
  }

  function getCardHandle(card) {
    let handle = card?.dataset?.productHandle || card?.dataset?.handle;
    if (!handle) {
      const link = card?.querySelector('a[href*="/products/"]');
      if (link) handle = extractHandleFromHref(link.href);
    }
    return handle || null;
  }

  function getColorForCard(card, slug) {
    const overrides = COLLECTION_PRODUCT_COLOR_OVERRIDES[slug];
    const handle = getCardHandle(card);
    if (overrides && handle && overrides[handle]) return overrides[handle];

     // Customer's live filter selection wins over the collection's hardcoded default
  const urlColors = getFilterColorsFromURL();
  if (urlColors) return urlColors;

    return COLLECTION_COLOR_MAP[slug];
  }

  function selectColorOnCard(card, slug) {
    if (!card || card.dataset.colorApplied === 'true') return;

    const colors = getColorForCard(card, slug);
    if (!colors) return;

    const inputs = Array.from(card.querySelectorAll('input[type="radio"][data-variant-id]'));
    if (!inputs.length) return;

    const candidates = Array.isArray(colors) ? colors : [colors];
    for (const color of candidates) {
      const wanted = String(color).trim().toLowerCase();
      // Case/whitespace-insensitive match — mirrors the Liquid comparison, so
      // "Off White" still matches a value stored as "OFF WHITE".
      const input = inputs.find(el => (el.value || '').trim().toLowerCase() === wanted);
      if (input) {
        card.dataset.colorApplied = 'true';
        // Always fire change, even when the Liquid already rendered this input
        // checked: the change handler is what swaps the card image and repoints
        // the product links at this variant.
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        return; // stop at the first color this product actually has
      }
    }
  }

  function autoSelectColor(scope = document) {
    const slug = getCurrentCollectionSlug();

     const hasFilterColor = !!getFilterColorsFromURL();
  if (!slug && !hasFilterColor) return;   // run if either a mapped collection OR a live filter is present
    // if (!slug) return;

    const cards = [];
    if (scope.matches?.('.card-product-custom-div')) cards.push(scope);
    scope.querySelectorAll?.('.card-product-custom-div').forEach(c => cards.push(c));

    cards.forEach(card => selectColorOnCard(card, slug));
  }

  // Catches products added later by pagination / infinite scroll / "load more",
  // even when the theme doesn't fire a `products:loaded` event.
  function attachColorObserver() {
    if (window.__collectionColorObserverAttached) return;
    window.__collectionColorObserverAttached = true;

    const observer = new MutationObserver(muts => {
      const slug = getCurrentCollectionSlug();
      if (!slug) return;

      const cards = new Set();
      muts.forEach(m => {
        m.addedNodes.forEach(node => {
          if (!(node instanceof HTMLElement)) return;
          if (node.matches?.('.card-product-custom-div')) cards.add(node);
          node.querySelectorAll?.('.card-product-custom-div').forEach(c => cards.add(c));
        });
      });

      if (cards.size) {
        requestAnimationFrame(() => cards.forEach(card => selectColorOnCard(card, slug)));
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { autoSelectColor(); attachColorObserver(); });
  } else {
    autoSelectColor();
    attachColorObserver();
  }

  // Fast path for themes that DO emit a products:loaded event.
  document.addEventListener('products:loaded', (e) => {
    if (!getCurrentCollectionSlug()) return;
    (e.detail?.items || []).forEach(item => autoSelectColor(item));
  });
  // Auto-select colors on collection pages end

  /* ------------------------------------------------------------------ *
   * Auto-select first variant on page load
   * (skipped on pages handled by the color logic above)
   * ------------------------------------------------------------------ */
  function autoSelectFirstVariant(scope = document) {
    if (getColorForCurrentPage()) return;

    scope.querySelectorAll('.card-product-custom-div').forEach(card => {
      const firstInput = card.querySelector('input[type="radio"][data-variant-id]');
      if (!firstInput) return;
      firstInput.checked = true;
      firstInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => autoSelectFirstVariant());
  } else {
    autoSelectFirstVariant();
  }

  // For infinite scroll / lazy loaded products
  document.addEventListener('products:loaded', (e) => {
    if (getColorForCurrentPage()) return;
    const newItems = e.detail?.items;
    if (!newItems) return;
    newItems.forEach(item => autoSelectFirstVariant(item));
  });
})();